import { render } from "./InclusaoEdicao.vue?vue&type=template&id=7b13229f&scoped=true&ts=true"
import script from "./InclusaoEdicao.vue?vue&type=script&lang=ts"
export * from "./InclusaoEdicao.vue?vue&type=script&lang=ts"

import "./InclusaoEdicao.vue?vue&type=style&index=0&id=7b13229f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b13229f"]])

export default __exports__